const statusSelecionaveis = ["ABERTO", "BAIXADO_PARCIAL"];
const limiteTitulos = 500;
const chavesPaginacao = ["page", "limite", "orderBy", "order"];

export const selecaoTitulosLote = {
  limiteTitulos,
  podeSelecionar: (conta) => statusSelecionaveis.includes(conta?.status),
  chaveBusca: ({ tipo, filtros = {} }) => {
    const filtrosSemPaginacao = Object.keys(filtros)
      .filter((chave) => !chavesPaginacao.includes(chave))
      .sort()
      .map((chave) => [chave, filtros[chave]]);
    return JSON.stringify([tipo, filtrosSemPaginacao]);
  },
  montaFiltroTitulosAbertos: ({ filtros = {} }) => {
    const statusFiltro = filtros.status
      ? String(filtros.status).split(",")
      : statusSelecionaveis;
    const status = statusFiltro.filter((item) =>
      statusSelecionaveis.includes(item),
    );
    if (!status.length) return null;
    return {
      ...filtros,
      status,
      restritiva: true,
      page: "1",
      limite: limiteTitulos,
    };
  },
  unirPorId: (itensAnteriores, novosItens) => {
    const idsNovos = new Set(novosItens.map((item) => item.id));
    return [
      ...itensAnteriores.filter((item) => !idsNovos.has(item.id)),
      ...novosItens,
    ];
  },
  contemTodas: (ids, linhasSelecionadas) => {
    const selecionadas = new Set(linhasSelecionadas);
    return ids.length > 0 && ids.every((id) => selecionadas.has(id));
  },
  mensagemLimite: (quantidade) =>
    `É possível processar até ${limiteTitulos} títulos por vez e a seleção teria ${quantidade}. Refine o filtro ou faça em partes.`,
};
